import { createContext, useContext } from 'react';

import type { AccountVerificationData } from './type.ts';

type AccountVerificationContextValue = {
  onSkip: () => void;
  updateData: (data: Partial<AccountVerificationData>) => void;
  loading: boolean;
};

export const AccountVerificationContext =
  createContext<AccountVerificationContextValue | null>(null);

export const useAccountVerification = () => {
  const ctx = useContext(AccountVerificationContext);
  if (!ctx)
    throw new Error(
      'useAccountVerification must be used within AccountVerification'
    );
  return ctx;
};
